import "./Form.css";
import React,{useReducer} from 'react';

function reducer(state,action){
    switch(action.type){
       case "name":
           return {
              ...state,
              name:action.nextName
           } 
       case "email":
           return {
              ...state,
              email:action.nextEmail
           } 
       case "subject":
           return {
              ...state,
              subject:action.nextSubject
           } 
       case "message":
           return {
              ...state,
              message:action.nextMessage
           } 
        case "clear":
            return {
               ...state,
               name:"",email:"",subject:"",message:""
            } 
       default:
          return state;
    }
}

function Form() {
  const[state,dispatch] = useReducer(reducer,{name:"",email:"",subject:"",message:""});
  console.log(state);
  function handleSubmit(event){
     event.preventDefault();
     if(state.name && state.email && state.subject && state.message){
        console.log("submitted");
        dispatch({type:"clear"});
     }else{
        alert("Enter all the feilds")
     }
  }
  return (
    <div className="form" onSubmit={handleSubmit}>
      <form>
          <label>Your Name</label>
          <input
           type="text" 
           value={state.name}
           onChange = {(e) =>dispatch({type:"name",nextName:e.target.value})}
           />
          <label>Email</label>
          <input 
          type="email"
          value={state.email}
          onChange = {(e) =>dispatch({type:"email",nextEmail:e.target.value})}
          />
          <label>Subject</label>
          <input 
          type="text"
          value={state.subject}
          onChange = {(e) =>dispatch({type:"subject",nextSubject:e.target.value})}
          />
          <label>Message</label>
          <textarea 
          type="text"
          value={state.message}
          onChange = {(e) =>dispatch({type:"message",nextMessage:e.target.value})}
          placeholder="type your message here"
          rows="3"
          />
          <button className="btn btn-submit" type="submit">Submit</button>

      </form>
    </div>
  )
}

export default Form
